import cn from 'classnames';
import { useContext } from 'react';

import BalancedMealsIcon from 'components/icons/signUp/BalancedMeals';
import CulinaryCollectionIcon from 'components/icons/signUp/CulinaryCollection';
import DietVarietyIcon from 'components/icons/signUp/DietVariety';
import ExpressIcon from 'components/icons/signUp/Express';
import ExtrasIcon from 'components/icons/signUp/Extras';
import FastAndFreshIcon from 'components/icons/signUp/FastAndFresh';
import HeartIcon from 'components/icons/signUp/Heart';
import MealKitsIcon from 'components/icons/signUp/MealKits';
import MoneyIcon from 'components/icons/signUp/Money';
import NutritionGoalsIcon from 'components/icons/signUp/NutritionGoals';
import OvenReadyIcon from 'components/icons/signUp/OvenReady';
import PencilIcon from 'components/icons/signUp/Pencil';
import PizzaIcon from 'components/icons/signUp/Pizza';
import PortionControlIcon from 'components/icons/signUp/PortionControl';
import ProteinPackedIcon from 'components/icons/signUp/ProteinPacked';
import RecyclingIcon from 'components/icons/signUp/Recycling';
import SaveTimeIcon from 'components/icons/signUp/SaveTime';
import { BrandContext } from 'context/BrandContext';
import styles from 'styles/components/signUpFunnel/intro/BoxToggle.module.scss';

const Icons = {
  BalancedMealsIcon,
  CulinaryCollectionIcon,
  DietVarietyIcon,
  ExpressIcon,
  ExtrasIcon,
  FastAndFreshIcon,
  HeartIcon,
  MealKitsIcon,
  MoneyIcon,
  NutritionGoalsIcon,
  OvenReadyIcon,
  PencilIcon,
  PizzaIcon,
  PortionControlIcon,
  ProteinPackedIcon,
  RecyclingIcon,
  SaveTimeIcon,
};

const BoxToggle = ({ children, handleClick, id, name, icon, selected }) => {
  const { brand } = useContext(BrandContext);

  const IconComponent = Icons[icon];

  return (
    <button
      id={id}
      name={name}
      className={cn(
        styles[brand],
        'textMd flex h-32 flex-col items-center justify-center rounded px-1',
        {
          [styles.selected]: selected,
          [styles.unselected]: !selected,
        }
      )}
      onClick={handleClick}
      role="checkbox"
      aria-checked={selected}
      aria-label={name}
    >
      {IconComponent && <IconComponent className="mb-1" />}
      {children}
    </button>
  );
};

BoxToggle.propTypes = {
  children: PropTypes.node.isRequired,
  handleClick: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
};

export default BoxToggle;
